import classNames from "classnames";
import { Text, type TextSize } from "~/components/Text/Text";
import type { ResponsiveProp } from "~/components/utils/responsiveProp";
import { CloseIcon } from "~/icons";
import styles from "./NotificationBanner.module.css";

export interface NotificationDetails {
  title?: string;
  body?: string;
}

export function NotificationBanner({
  details,
  onDismiss,
}: {
  details: NotificationDetails | null;
  onDismiss: () => void;
}) {
  let size: ResponsiveProp<TextSize> = "small";
  if (details?.title && details.body) {
    size = "xsmall";
  }
  const bannerClassName = classNames(styles.notificationBanner, {
    [styles.active]: Boolean(details),
  });
  return (
    <div className={bannerClassName}>
      <div
        style={{
          float: "right",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          height: "100%",
          marginRight: "10px",
        }}
      >
        <CloseIcon
          onClick={onDismiss}
          aria-label="Close"
          style={{
            borderRadius: "4px",
            transition: "all 0.2s ease",
            cursor: "pointer",
          }}
        />
      </div>
      <div>
        {details?.title && (
          <Text weight="strong" size={size}>
            {details.title}
          </Text>
        )}
        {details?.body && <Text size={size}>{details.body}</Text>}
      </div>
    </div>
  );
}
